export enum FillOutDirection {
  Across = 'Across',
  Down = 'Down'
}
